import { Box, Button, Grid, Grow, Stack, Typography } from "@mui/material";
import FixedSection from "Components/FixedSection";
import { useContext, useEffect, useState } from "react";
import DialogForm from "./DialogForm";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "methods/api";
import axios from "axios";
import { ProductSliderType } from "types/HardProducts";
import SliderAndTable from "./SliderAndTable";
import Spinner from "pages/SpinnerPage/Spinner";
import { homeContext } from "pages/HomeContext";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import TelegramIcon from "@mui/icons-material/Telegram";
import SettingsPhoneIcon from "@mui/icons-material/SettingsPhone";
import CallIcon from "@mui/icons-material/Call";
import Helmet from "react-helmet";
import { Avatar } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import StarIcon from "@mui/icons-material/Star";

function SliderHurhada() {
  const [t, i18n] = useTranslation();
  const { homeData } = useContext(homeContext);
  const [handelIcon, sethandelIcon] = useState(true);
  const actions = [
    {
      icon: <WhatsAppIcon sx={{ color: "#fff", fontSize: "40px" }} />,
      name: "WhatsApp",
      bgcolor: "#25d366",
      link: `${homeData?.contactus.whatsup}`,
    },
    {
      icon: <TelegramIcon sx={{ color: "#fff", fontSize: "40px" }} />,
      name: "Telegram",
      bgcolor: "#279dd8",
      link: `${homeData?.contactus.telegram}`,
    },
    // {
    //   icon: (
    //     <SettingsPhoneIcon
    //       sx={{
    //         color: "#784F99",
    //         fontSize: "40px",
    //         background: "#fff",
    //         borderRadius: "25px",
    //       }}
    //     />
    //   ),
    //   name: "Viber",
    //   bgcolor: "#784F99",
    //   link: `${homeData?.contactus.viber}`,
    // },
    // {
    //   icon: <CallIcon sx={{ color: "#fff", fontSize: "40px" }} />,
    //   name: "Phone",
    //   bgcolor: "green",
    //   link: `${homeData?.contactus.phone}`,
    // },
  ];
  const { name } = useParams();
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState<"none" | "loading" | "done">("none");
  const [productInfo, setProductInfo] = useState<ProductSliderType | undefined>(
    undefined
  );
  function getProductData() {
    setStatus("loading");
    //
    axios
      .get<{ data: ProductSliderType }>(api(`product/${name}`))
      .then(({ data }) => {
        setStatus("done");
        setProductInfo(data.data);
      })
      .catch((error) => {
        setStatus("none");
      });
  }
  useEffect(() => {
    getProductData();
  }, [name]);
  function bookTravel(name: string) {
    axios
      .post(api(`book-count`), { title: name, product_id: name })
      .then((res) => {})
      .catch((err) => {});
  }
  function ReviewCards({ reviews }: { reviews: ProductSliderType["reviews"] }) {
    const defaultAvatar = "https://via.placeholder.com/60";
    return (
      <Box sx={{ mt: 4 }}>
        <Typography variant="h5" fontWeight={600} textAlign="center" mb={3}>
        {homeData?.siteInformation.reviews}

        </Typography>
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={24}
          slidesPerView={1}
          pagination={{ clickable: true }}
          autoplay={{ delay: 4000 }}
          style={{ paddingBottom: 32 }}
          breakpoints={{
            600: { slidesPerView: 2 },
            900: { slidesPerView: 3 },
          }}
        >
          {reviews.map((review, index) => (
            <SwiperSlide key={index}>
              <Box
                component="a"
                href={review.link}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: 3,
                  border: '1px solid #eee',
                  borderRadius: 2,
                  textAlign: 'center',
                  height: '100%',
                  minHeight: 220,
                  boxSizing: 'border-box',
                  mx: 'auto',
                  cursor: 'pointer',
                  textDecoration: 'none',
                  '&:hover .review-name': {
                    textDecoration: 'underline',
                  },
                }}
              >
                <Avatar
                  src={review.avatar || defaultAvatar}
                  sx={{ width: 60, height: 60, mb: 1 }}
                />
                <Typography fontWeight="bold" variant="h6" className="review-name" sx={{ color: '#1976d2' }}>
                  {review.name}
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                  {(() => {
                    const stars = review.stars ?? 4.5;
                    const fullStars = Math.floor(stars);
                    const hasHalfStar = stars % 1 >= 0.5;
                    return (
                      <>
                        {Array.from({ length: fullStars }, (_, i) => (
                          <StarIcon key={i} sx={{ color: '#FFD700' }} />
                        ))}
                        {hasHalfStar && <StarIcon sx={{ color: '#FFD700', opacity: 0.5 }} />}
                      </>
                    );
                  })()}
                </Box>
                <Typography variant="body2" sx={{ mt: 1, color: 'inherit' }}>
                  {review.massege}
                </Typography>
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    );
  }

  return (
    <>
      {status == "done" ? (
        <>
          <Helmet>
            <title> {productInfo?.product.title}</title>
            <meta
              name="description"
              content={productInfo?.product.metaDescription}
            />
            <meta name="keywords" content={productInfo?.product.metaTags} />
          </Helmet>
          <FixedSection title="" />
          <Stack
            sx={{
              py: 8,
              width: { md: "60%", xs: "90%" },
              display: "flex",
              margin: " 0 auto",
            }}
          >
            <SliderAndTable productInfo={productInfo} />
            {handelIcon && (
              <Grow in={handelIcon} timeout={1000}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {actions.map((item) => (
                    <Box
                      key={item.name}
                      component={"a"}
                      onClick={() => {
                        bookTravel(item.name);
                      }}
                      target="_blank"
                      href={`${item.link}`}
                      sx={{
                        backgroundColor: item.bgcolor,
                        borderRadius: "50%",
                        p: 1,
                        ml: 2,
                      }}
                    >
                      {item.icon}
                    </Box>
                  ))}
                </Box>
              </Grow>
            )}

            {handelIcon == false && (
              <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
                <Button
                  sx={{ borderRadius: "10px", padding: "10px 20px" }}
                  variant="contained"
                  onClick={() => {
                    // Adding a delay before showing the icons with animation
                    setTimeout(() => {
                      sethandelIcon(true);
                    }, 100); // 1000ms delay (1 second)
                  }}
                >
                  {homeData?.siteInformation.book_now}
                </Button>
              </Box>
            )}
            <ReviewCards reviews={productInfo?.reviews || []} />

          </Stack>
          <DialogForm open={open} setOpen={setOpen} />
        </>
      ) : (
        <Spinner />
      )}
    </>
  );
}

export default SliderHurhada;
